import React from "react";
import styles from "./message-user.module.css";


const MessageUser = (props) => {
  return (
    <div className={`${styles.container} ${styles.container_user}`}>
      <div className={styles.message}>
        {props.children}
      </div>
      <div className={styles.you_text}>
        <p>You</p>
      </div>
    </div>
  );
};

export { MessageUser };
